import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTwitchBrandedStyle0 = cosmosIconCss;

const CosmosIconTwitchBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTwitchBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ce1a67094985ff62f1de0ebd5b183a239fab0da6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fb05bd6157d843869dd4bcc095e92f418ec3ccd3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2980155589e08dd10b424c628ee5127a7be70c93', d: "M6.857 3 4 5.857v10.286h3.429V19l2.857-2.857h2.285L17.714 11V3H6.857Z", fill: "#9146FF" }), h("path", { key: 'a7219dcb9d067aefce4e3e6aad0dc0a187227e25', d: "m16.571 10.429-2.285 2.285H12l-2 2v-2H7.429V4.143h9.142v6.286Z", fill: "#fff" }), h("path", { key: 'c089ce81ce7b13b9a52b9af305b6ee5c93bbcf78', d: "M13.714 6.143h1.143V9.57h-1.143V6.143Zm-3.143 0h1.143V9.57h-1.143V6.143Z", fill: "#9146FF" }))));
    }
    static get style() { return CosmosIconTwitchBrandedStyle0; }
}, [1, "cosmos-icon-twitch-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-twitch-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-twitch-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTwitchBranded$1);
            }
            break;
    } });
}

const CosmosIconTwitchBranded = CosmosIconTwitchBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTwitchBranded, defineCustomElement };
